<template>
  <div>
    <div style="height:250px"/>
      <v-layout justify-center>
        <h1 class="fade-in delay1" style="font-size: 50px;">管理者</h1>
      </v-layout>

      <v-layout justify-center>
        <v-card
          class="fade-in delay1"
          color="transparent"
          elevation="0"
          width="800"
        >
          <v-card-text style="font-size: 15px;">
            このページでは、アプリケーションの管理・運用を行う管理者に関する機能のご紹介をします。<br/>
            管理者に対する機能は主に2つであり、「管理者登録」と「拠点登録」があります。
            これらの機能があることによって、アプリケーションは管理者を確保し、販売を行う拠点を決定します。
            各々の詳細は以下のセクションにて説明します。
          </v-card-text>
        </v-card>
      </v-layout>

      <div style="height: 300px;"/>

      <div id="manager">
        <v-layout justify-center class="mb-5">
          <h1>管理者登録</h1>
        </v-layout>

        <v-row justify="center" no-gutters class="mr-10">
          <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
            <pics-slider :pics="getPics(pics.managers)"/>

            <slider-dialog :pics="getPics(pics.managers)"/>
          </v-col>

          <v-col align-self="center">
            <v-card
              color="transparent"
              elevation="0"
            >
              <v-card-text style="font-size: 15px;">
                アプリケーションの管理・運用を行う管理者を新たに登録する機能です。
                この操作を行うことで、既にある販売拠点（コミュニティの拠点）、または新たに立ち上げる拠点に対して、新しい管理者を登録することができます。
                管理者登録に必要なフローは大きく分けて2つです。<br/><br/>
                
                1つ目は、既存の管理者による仮登録です。このステップは新しい管理者を仮登録するとともに、意図しない管理者の追加を防ぐ働きをします。
                既存管理者は管理アプリのコンソールにアクセスし、ナビゲーションバーより「Managers」を選択し、管理者管理ページを開きます。
                ページを開くと右下にフローティングボタンがあり、そこから新規管理者の仮登録を行うことができます。
                仮登録に必要な情報は、新規管理者のメールアドレスとその管理者が所属する拠点の2つです。
                なお、本アプリの機能上、メールアドレスはGoogle アカウントのものを使用する必要があります。
                また所属拠点は、既存の拠点から選択、もしくは新しく追加することが可能です。
                新拠点の追加に関しては、次のセクションで説明します。<br/><br/>

                2つ目のステップは、新規管理者による本登録です。このステップを経て、初めて管理者として管理アプリにアクセスできるようになります。
                新規管理者は、本管理者による仮登録完了後、本アプリの「/manager/signin」のパスにアクセスし、登録フォームを入力します。
                本登録に必要な情報は、新規管理者の名前です。イニシャルを大文字にし、姓名の間に半角空白を挿入した名前を入力します。
                入力終了後、フォームの下にある「SIGN IN WITH GOOGLE ACCOUNT」ボタンを押下し、サインインするGoogleアカウントを選択します。
                ここで選択するアカウントは、先程仮登録で登録したものである必要があります。
                このサインイン処理が終わると、管理者登録のフローがすべて完了し、新規管理者は管理アプリにアクセスができるようになります。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div style="height: 300px;"/>

      <div id="base">
        <v-layout justify-center>
          <h1>拠点登録</h1>
        </v-layout>

        <v-row justify="center" class="mt-5">
          <v-col align-self="center" cols="12" sm="12" md="12" lg="6" xl="6">
            <pics-slider :pics="getPics(pics.bases)"/>

            <slider-dialog :pics="getPics(pics.bases)"/>
          </v-col>

          <v-col align-self="center">
            <v-card
              color="transparent"
              elevation="0"
            >
              <v-card-text style="font-size: 15px;">
                新しい拠点を追加したい場合は、「管理者登録」機能で新しい管理者を登録する際に、同時に登録を行います。
                具体的には、既存の管理者による仮登録時に、拠点選択のプルダウンで「Add New Base」を選択します。
                選択すると入力フォームが現れるので、そこに拠点名を入力して管理者登録を完了させます。
                これにより新規管理者は、通常であれば既存の拠点に登録されるところを、新規の拠点に対して登録されます。
                以上の登録処理を完了すると、新規管理者によって新規拠点の運用が始められます。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div style="height: 100px"/>
  </div>
</template>

<script>
import scrollToMixin from '../../../mixin/scrollToMixin'
import PicsSlider from '../components/PicsSlider'
import SliderDialog from '../components/SliderDialog.vue';

export default {
  mixins: [scrollToMixin],
  components: {
    PicsSlider,
    SliderDialog,
  },
  data: () => ({
    pics: {
      managers: ["navigation_2.png", "manager_register_1.png", "manager_register_2.png", "manager_register_4.png"],
      bases: ["manager_register_1.png", "manager_register_3.png"]
    }
  }),
  methods: {
    /**@param {Array<String>} pics */
    getPics: function(pics){
      const img = [];
      pics.map((value) => {
        img.push(require("../../../images/manager/" + value));
      })
      return img;
    }
  }
}
</script>

<style>
@import '../../../styles/fade.css';
</style>